export default "__VITE_ASSET__1f740e87__"